// src/components/CookieBanner.js
import React, { useState, useEffect } from 'react';
import './CookieBanner.css';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
  };

  const handleRejectAll = () => {
    localStorage.setItem('cookieConsent', 'essential');
    setIsVisible(false);
  };

  const handleCustomize = () => {
    // For now, this just closes the banner or can be expanded to a modal
    localStorage.setItem('cookieConsent', 'custom');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>
          We use cookies to enhance your experience, analyze site traffic, and for essential authentication via WorkOS.
          By clicking "Accept All", you consent to our use of cookies. <strong>Essential authentication cookies cannot be rejected.</strong>
        </p>
        <div className="cookie-links">
          <button className="cookie-link">Privacy Policy</button>
          <button className="cookie-link">Do Not Sell My Personal Information</button>
        </div>
      </div>
      <div className="cookie-actions">
        <button className="btn btn-outline" onClick={handleCustomize}>Customize</button>
        <button className="btn btn-secondary" onClick={handleRejectAll}>Reject All</button>
        <button className="btn btn-primary" onClick={handleAcceptAll}>Accept All</button>
      </div>
    </div>
  );
};

export default CookieBanner;
